document.addEventListener("DOMContentLoaded", () => {

  const toggleNoWishlistMessage = (show) => {
    const msg = document.querySelector(".no-wishlist-message");
    if (msg) msg.classList.toggle("d-none", !show);
  };

  const updateWishlistCount = () => {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const countElement = document.querySelector(".wishlist-count");
    if (countElement) countElement.textContent = wishlist.length;
  };

  function formatPrice(priceInCents) {
    const price = priceInCents / 100;
    const activeCurrency = window?.Shopify?.currency?.active || 'USD';

    let formatted = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: activeCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);

    if (activeCurrency.toUpperCase() === 'INR') {
      formatted = formatted.replace('₹', '').trim();
      return 'Rs. ' + formatted;
    }
    return formatted;
  }

  const timeAgo = (timestamp) => {
    const seconds = Math.floor((Date.now() - timestamp) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);

    if (seconds < 60) return "Just now";
    if (minutes < 60) return `${minutes} min ago`;
    if (hours < 24) return `${hours} hours ago`;
    if (days < 30) return `${days} days ago`;
    return `${months} months ago`;
  };

  const modifyWishlist = (handle, add) => {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (add) {
      if (!wishlist.find((item) => item.handle === handle)) {
        wishlist.push({ handle, addedAt: Date.now(), order: wishlist.length });
      }
    } else {
      wishlist = wishlist.filter((item) => item.handle !== handle);
    }

    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    updateWishlistCount();
  };

  const addProductToWishlistUI = (product, addedAt) => {
    const wishlistContainer = document.getElementById("wishlistContainer");
    if (!wishlistContainer) return;

    const productCol = document.createElement("div");
    productCol.classList.add("wish-item");

    productCol.innerHTML = `
      <div class="item-box">
        <div class="image-wrapper">
          <a href="${product.url}"><img src="${product.images[0]}&width=261" data-src="${product.images[0]}" loading="lazy" alt="${product.title}" class="img-fluid lazy-collection"></a>
          <span class="wishlist-remove" data-product-handle="${product.handle}">
            <i class="ri-delete-bin-line"></i>
          </span>
        </div>
        <div class="item-info w-100">
          <a href="${product.url}"><h5>${product.title}</h5></a>
          <p>
            ${formatPrice(product.price)}
            ${product.compare_at_price ? `<del>${formatPrice(product.compare_at_price)}</del>` : ""}
          </p>
          <p class="added-time"><span><i class="ri-time-line"></i>${timeAgo(addedAt)}</span> 
          <span class="wishlist-remove d-none" data-product-handle="${product.handle}">
            <i class="ri-delete-bin-line"></i>
          </span></p>
        </div>
      </div>
    `;

    wishlistContainer.appendChild(productCol);
    toggleNoWishlistMessage(false);

    productCol.querySelectorAll(".wishlist-remove").forEach(btn => {
      btn.addEventListener("click", () => {
        modifyWishlist(product.handle, false);
        productCol.remove();
        if (!wishlistContainer.children.length) toggleNoWishlistMessage(true);
        updateWishlistButtonState();
      });
    });
  };

  const loadWishlist = () => {
    const wishlistContainer = document.getElementById("wishlistContainer");
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (!wishlistContainer) return;

    wishlistContainer.innerHTML = "";
    toggleNoWishlistMessage(wishlist.length === 0);

    const fetches = wishlist.map(item =>
      fetch(`/products/${item.handle}.js`)
        .then(res => res.json())
        .then(product => ({ product, addedAt: item.addedAt, order: item.order }))
    );

    Promise.all(fetches).then(results => {
      results
        .sort((a, b) => a.order - b.order) 
        .forEach(item => addProductToWishlistUI(item.product, item.addedAt));
    });
  };

  const updateWishlistButtonState = () => {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    document.querySelectorAll(".wishlist").forEach((btn) => {
      const handle = btn.dataset.productHandle;

      if (wishlist.find((item) => item.handle === handle)) {
        btn.classList.add("filled");
        btn.classList.add("fill");
      } else {
        btn.classList.remove("filled");
        btn.classList.remove("fill");
      }
    });

    updateWishlistCount();
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest(".wishlist");
    if (!button) return;

    event.preventDefault();

    const handle = button.dataset.productHandle;
    const isAdding = !button.classList.contains("filled") && !button.classList.contains("fill");

    if (isAdding) {
      button.classList.add("filled");
      button.classList.add("fill");
      modifyWishlist(handle, true);

      fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          const wishlist = JSON.parse(localStorage.getItem("wishlist"));
          const obj = wishlist.find((i) => i.handle === handle);
          addProductToWishlistUI(product, obj.addedAt);
        });

    } else {
      button.classList.remove("filled");
      button.classList.remove("fill");

      modifyWishlist(handle, false);

      const removedItem = document.querySelector(`.wishlist-remove[data-product-handle="${handle}"]`);
      removedItem?.closest(".wish-item")?.remove();

      const wishlistContainer = document.getElementById("wishlistContainer");
      if (!wishlistContainer.children.length) toggleNoWishlistMessage(true);
    }

    updateWishlistButtonState();
  });

  updateWishlistButtonState();
  loadWishlist();

  window.updateWishlistButtonState = updateWishlistButtonState;
});
